export default "__VITE_ASSET__CLUFQoHL__"